<template>
    <div>
      <LoginForm @wxlogin="(e) => getWXInfo(e)" />
      <MobileForm />
      <BindForm />
    </div>
</template>
<script>
import LoginForm from './form.vue';
import MobileForm from './mobile.vue';
import BindForm from './bind.vue';
export default {
  props: {
    visible: Boolean,
  },
  components: {
    LoginForm,
    MobileForm,
    BindForm,
  },
};
</script>
